import React from 'react';
import { Check, Zap } from 'lucide-react';
import { Button } from './ui/Button';
interface BundleCardProps {
  quantity: number;
  price: string;
  originalPrice?: string;
  savings?: number;
  isBestValue?: boolean;
  bonuses?: string[];
  onSelect: () => void;
  productImage?: string;
}
export function BundleCard({
  quantity,
  price,
  originalPrice,
  savings,
  isBestValue,
  bonuses = [],
  onSelect,
  productImage = 'https://cdn.magicpatterns.com/uploads/q5pbc7UPXB7yZsJKNiRqwd/LymphoriaX_(6).png'
}: BundleCardProps) {
  return <div className={`
      relative flex flex-col rounded-2xl border-2 p-6 bg-white transition-all
      ${isBestValue ? 'border-[#D4AF37] shadow-xl scale-105 z-10' : 'border-gray-200 shadow-sm hover:border-[#D4AF37]/50'}
    `} data-id="element-15">
      {isBestValue && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#D4AF37] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide whitespace-nowrap shadow-md" data-id="element-16">
          Más Popular
        </div>}

      {/* Product Image Stack */}
      <div className="relative h-32 mb-6 flex items-center justify-center" data-id="element-17">
        {quantity === 1 ? <img src={productImage} alt="StingFit Pack" className="h-full w-auto object-contain" data-id="element-18" /> : quantity === 2 ? <div className="relative h-full w-full flex items-center justify-center" data-id="element-19">
            <img src={productImage} alt="StingFit Pack" className="h-full w-auto object-contain absolute left-4 -rotate-6 opacity-70" data-id="element-20" />
            <img src={productImage} alt="StingFit Pack" className="h-full w-auto object-contain absolute right-4 rotate-6" data-id="element-21" />
          </div> : quantity === 3 ? <div className="relative h-full w-full flex items-center justify-center" data-id="element-22">
            <img src={productImage} alt="StingFit Pack" className="h-full w-auto object-contain absolute left-2 -rotate-12 opacity-50" data-id="element-23" />
            <img src={productImage} alt="StingFit Pack" className="h-full w-auto object-contain relative z-10" data-id="element-24" />
            <img src={productImage} alt="StingFit Pack" className="h-full w-auto object-contain absolute right-2 rotate-12 opacity-50" data-id="element-25" />
          </div> : <div className="relative h-full w-full flex items-center justify-center" data-id="element-26">
            <div className="grid grid-cols-3 grid-rows-2 gap-0.5 h-full w-full" data-id="element-27">
              {[...Array(6)].map((_, i) => <img key={i} src={productImage} alt="StingFit Pack" className="h-full w-full object-contain opacity-70" data-id="element-28" />)}
            </div>
          </div>}
      </div>

      <div className="text-center mb-6 pt-2" data-id="element-29">
        <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-30">
          Pack de {quantity} {quantity === 1 ? 'Mes' : 'Meses'}
        </h3>
        <div className="flex items-center justify-center gap-3 mb-2" data-id="element-31">
          {originalPrice && <span className="text-gray-400 line-through text-lg" data-id="element-32">
              {originalPrice}
            </span>}
          <span className="text-3xl font-bold text-[#2D5016]" data-id="element-33">{price}</span>
        </div>
        {savings && <span className="inline-block bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded-md" data-id="element-34">
            Ahorras {savings}%
          </span>}
      </div>

      <div className="flex-grow space-y-3 mb-6" data-id="element-35">
        <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-36">
          <Check className="w-4 h-4 text-[#D4AF37]" data-id="element-37" />
          <span data-id="element-38">Envío Gratis Hoy</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-39">
          <Check className="w-4 h-4 text-[#D4AF37]" data-id="element-40" />
          <span data-id="element-41">Garantía de 90 Días</span>
        </div>
        {bonuses.map((bonus, idx) => <div key={idx} className="flex items-center gap-2 text-sm text-gray-600 font-medium" data-id="element-42">
            <Check className="w-4 h-4 text-[#D4AF37]" data-id="element-43" />
            <span data-id="element-44">{bonus}</span>
          </div>)}
      </div>

      <div className="space-y-3" data-id="element-45">
        <Button variant={isBestValue ? 'primary' : 'outline'} fullWidth onClick={onSelect} className={`${isBestValue ? 'group shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all' : ''} font-bold`} data-id="element-46">
          {isBestValue ? <>
              <Zap className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform" data-id="element-47" />
              EMPEZAR MI TRANSFORMACIÓN
            </> : 'Elegir Este Pack'}
        </Button>

        {isBestValue && <p className="text-xs text-center text-gray-500 font-medium flex items-center justify-center gap-1" data-id="element-48">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-49"></span>
            Envío inmediato • Stock limitado
          </p>}
      </div>
    </div>;
}